import React, { useState, useEffect } from 'react';
import { Card, CardContent } from './ui/card';
import { Button } from './ui/button';
import { X, Sparkles } from 'lucide-react';

const PageGuide = ({ icon, title, description, actions, onActionClick, children }) => {
  const [show, setShow] = useState(() => {
    return localStorage.getItem('hideStepGuide') !== 'true';
  });

  // Listen for guide visibility changes
  useEffect(() => {
    const handleGuideChange = () => {
      setShow(localStorage.getItem('hideStepGuide') !== 'true');
    };
    window.addEventListener('guideVisibilityChanged', handleGuideChange);
    return () => window.removeEventListener('guideVisibilityChanged', handleGuideChange);
  }, []);

  const handleDismiss = () => {
    setShow(false);
    localStorage.setItem('hideStepGuide', 'true');
    window.dispatchEvent(new Event('guideVisibilityChanged'));
  };

  if (!show) return null;

  return (
    <Card className="bg-blue-50 border-blue-200">
      <CardContent className="pt-6">
        <div className="flex items-center justify-between">
          <div className="flex-1">
            <div className="flex items-center gap-3">
              <div className="w-10 h-10 bg-blue-500 rounded-full flex items-center justify-center flex-shrink-0 text-white font-bold text-lg">
                {icon || '📘'}
              </div>
              <div className="flex-1">
                <h3 className="font-semibold text-gray-900">{title}</h3>
                {description && (
                  <p className="text-sm text-gray-600 mt-1">{description}</p>
                )}
                {children}
                
                {/* Action buttons */}
                {actions && actions.length > 0 && (
                  <div className="flex gap-2 mt-3">
                    {actions.map((action, index) => (
                      <Button
                        key={index}
                        size="sm"
                        variant="outline"
                        onClick={() => onActionClick && onActionClick(action.action)}
                        className="bg-white hover:bg-blue-100 border-blue-300 text-blue-700 font-medium"
                      >
                        {action.icon === '✨' && <Sparkles className="w-4 h-4 mr-1" />}
                        {action.label}
                      </Button>
                    ))}
                  </div>
                )}
              </div>
            </div>
          </div>
          <Button 
            variant="ghost"
            size="sm"
            onClick={handleDismiss}
            className="text-gray-500 hover:text-gray-700 ml-4 flex-shrink-0"
          >
            <X className="w-4 h-4" />
            Dismiss
          </Button>
        </div>
      </CardContent>
    </Card>
  );
};

export default PageGuide;
